import styled from 'styled-components';

export default styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;